import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.user
 * @constructor
 */
export class UpdateUserModel extends BaseModel {
  /**
   * @param {string} [id]
   * @param {string} [firstName]
   * @param {string} [lastName]
   * @param {string} [displayName]
   * @param {string} [bio]
   * @param {loavies.models.user.UpdateUserPublicDataModel} [publicData]
   * @param {loavies.models.user.UpdateUserPrivateDataModel} [privateData]
   * @param {loavies.models.user.UpdateUserMetaDataModel} [metadata]
   * @param {Object} [protectedData]
   * @param {string} [profileImageId]
   */
  constructor({
    id,
    firstName,
    lastName,
    displayName,
    bio,
    publicData,
    privateData,
    metadata,
    protectedData,
    profileImageId,
  }) {
    super()

    /** @type {string} */
    if (!this.isUndefined(id)) this.id = id

    /** @type {string} */
    if (!this.isUndefined(firstName)) this.firstName = firstName

    /** @type {string} */
    if (!this.isUndefined(lastName)) this.lastName = lastName

    /** @type {string} */
    if (!this.isUndefined(displayName)) this.displayName = displayName

    /** @type {string} */
    if (!this.isUndefined(bio)) this.bio = bio

    /** @type {loavies.models.user.UpdateUserPublicDataModel} */
    if (!this.isUndefined(publicData)) this.publicData = publicData

    /** @type {loavies.models.user.UpdateUserPrivateDataModel} */
    if (!this.isUndefined(privateData)) this.privateData = privateData

    /** @type {loavies.models.user.UpdateUserMetaDataModel} */
    if (!this.isUndefined(metadata)) this.metadata = metadata

    /**
     * TODO: When used UpdateUserProtectedDataModel needs to be added
     * @type {Object} */
    if (!this.isUndefined(protectedData)) this.protectedData = protectedData

    /** @type {string} */
    if (!this.isUndefined(profileImageId)) this.profileImageId = profileImageId
  }
}
